var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistoryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "none",
    viewBox: "0 0 24 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#97A2AB",
    d: "M13.889 5.556h-1.667v5.555l4.756 2.822.8-1.344-3.89-2.311V5.556zM13.333 0c-2.652 0-5.195 1.054-7.07 2.929C4.386 4.804 3.332 7.348 3.332 10H0l4.4 4.478L8.889 10H5.556c0-2.063.819-4.041 2.278-5.5 1.458-1.458 3.437-2.278 5.5-2.278 2.062 0 4.04.82 5.5 2.278C20.291 5.96 21.11 7.937 21.11 10s-.82 4.041-2.278 5.5c-1.459 1.458-3.437 2.278-5.5 2.278-2.144 0-4.089-.878-5.489-2.29l-1.577 1.579C8.077 18.889 10.556 20 13.333 20c2.652 0 5.196-1.054 7.071-2.929 1.876-1.875 2.93-4.419 2.93-7.071s-1.054-5.196-2.93-7.071C18.53 1.054 15.986 0 13.334 0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.100a4aa2788cb21d5f89a7690fde556e.svg";
export { ForwardRef as ReactComponent };